"use script";

angular.module("core")
.constant("ONBOARDING_USER_VERIFICATION_TYPES", {
    "bank_transfer": "bank_transfer_onboarding",
    "credit_card": "credit_card_onboarding"
})
.constant("PAYMENT_USER_VERIFICATION_TYPES", {
    "bank_transfer": "bank_transfer_payment",
    "credit_card": "credit_card_payment"
})
.constant("PAYMENT_USER_VERIFICATION_REQUIRED", [
    "bank_transfer",
    "credit_card"
]);



//////////////////
// WEBPACK FOOTER
// ./core/user-verification/user-verification.constant.js
// module id = 389
// module chunks = 0